import { Component, OnInit } from '@angular/core';

import { AppSettings } from '../appSettings';

import { Subscription } from 'rxjs';

import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import { AppFormat } from '../appFormat';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SearchService } from '../services/search.service';
import { CouponService } from '../services/coupon.service';
import { ICoupon } from '../interfaces/coupon';
import { IUsersystem } from '../interfaces/usersystem';
import { OperadorService } from '../services/operador.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
  host: { 'class': 'wrapper-coupons' }
})
export class CouponsComponent implements OnInit {

  public operador: IUsersystem

  public num_todos: number = 0
  public num_ativo: number = 0
  public num_agendado: number = 0
  public num_expirado: number = 0

  public page: number = 1
  public openid: number = null

  public tab: string = 'ativo'

  public open: boolean = false

  public coupons: ICoupon[]
  public coupon: ICoupon
  public couponUrl: string = ''
  public isCopy: boolean = false
  public showLink: boolean = false

  public loadingCoupon: boolean = false
  public loadingDetail: boolean = false
  public loadingTab: boolean = false

  public loadingDelete: boolean = false
  public showConfirmDelete: boolean = false
  public isDeleteCupom: boolean = false

  public optionOpen: boolean = false
  public optionTimeout: any = null

  private query

  public couponFrm: FormGroup

  public status: FormControl

  public subscribeSearch: Subscription

  public search: string = ''
  private timeoutSearch = null

  public selector: string = '.wrapper-coupons';

  constructor(private _searchService: SearchService, private _couponService: CouponService, private _operadorService: OperadorService) {
    this.query = { page: this.page }

    this.operador = this._operadorService.getOperador()

    this.subscribeSearch = this._searchService._searchCoupon.subscribe(res => {
      this.search = res
      if (this.timeoutSearch) clearTimeout(this.timeoutSearch)

      this.timeoutSearch = setTimeout(()=>{

        this.loadingTab = true
        /*
        this.num_todos = 0
        this.num_ativo = 0
        this.num_agendado = 0
        this.num_expirado = 0
        */
        this.closeDetail()
        this.changeTab(this.tab)

      }, 300)
    })
  }

  ngOnInit(): void {
    this.coupons = []
    this.coupon = {
      idcupom: 0
    }

    this.createFormControls()
    this.createForm()

    this.loadingTab = true
    this.query['situacao'] = 'ativo'
    this.find()
  }

  ngOnDestroy(): void {
    this.subscribeSearch.unsubscribe()
  }

  createFormControls() {
    this.status = new FormControl('')
  }

  createForm() {
    this.couponFrm = new FormGroup({
      status: this.status
    })
  }

  showURL() {
    this.showLink = !this.showLink
  }

  showDeleteCupom() {
    this.isDeleteCupom = !this.isDeleteCupom
    if (this.isDeleteCupom) {
      this.toggleOptions()
    }
  }

  onScroll() {
    if (!this.loadingCoupon) {
      this.page = this.page + 1;
      this.find()
    }
  }

  find() {
    this.loadingCoupon = true

    this.query['page'] = this.page

    if (this.search != '') {
      this.query['search'] = this.search
    } else {
      if (this.query['search']) {
        delete this.query['search']
      }
    }

    //str: string, sort: string, direction: string, page: number

    this._couponService.search(this.query).subscribe(res => {
      this.coupons = this.page > 1 ? this.coupons.concat(res.coupons) : res.coupons

      if (res.num_todos) {
        this.num_todos = res.num_todos
        this.num_ativo = res.num_ativo
        this.num_agendado = res.num_agendado
        this.num_expirado = res.num_expirado
      }

      this.loadingCoupon = false
      this.loadingTab = false
    })
  }

  toggleOptions(): void {
    this.optionOpen=!this.optionOpen

    this.clearOptions()
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout)

      this.optionTimeout = setTimeout(()=>{
        this.optionOpen = false
      }, 2000)
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout)
  }

  changeTab(tab): void {
    this.tab = tab
    this.page = 1

    this.loadingTab = true

    delete this.query['situacao']

    switch(tab)
    {
      case 'ativo':
        this.query['situacao'] = 'ativo'
        break
      case 'agendado':
        this.query['situacao'] = 'agendado'
        break
      case 'expirado':
        this.query['situacao'] = 'expirado'
    }

    this.find()
  }

  onCopy() {
    this.isCopy = true
    setTimeout(()=>{
      this.isCopy = false
    }, 300)
  }

  onDeleteCupom() {
    Swal.fire({
      title: 'Você realmente excluir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingDelete = true
        this._couponService.delete(this.coupon.idcupom).subscribe(res => {
          if (res['success']) {
            this.showConfirmDelete = true
            this.coupons.splice(this.openid, 1);
            switch(this.tab){
              case 'ativo':
                this.num_ativo = this.num_ativo - 1
                break;
              case 'agendado':
                this.num_agendado = this.num_agendado - 1
                break;
              case 'expirado':
                this.num_expirado = this.num_expirado - 1
                break;
            }
            setTimeout(()=>{
              this.closeDetail()
            }, 500)
          } else {
            Swal.fire("Ops!", "Ocorreu um erro ao tentar excluir.", "error")
          }
          this.loadingDelete = false
        })
      }
    })
  }

  //{{ coupon.tipo_requisito == 'V' ? 'Compra mínima R$' + (coupon.requisito  | number:'1.0-2') : (coupon.requisito  | number:'1.0-2') + (coupon.requisito != '1' ? ' itens' : ' item' ) +' mínimo na compra' }}<br>
  requisitoCupom() {
    // ?  : (tipo_requisito.value == 'P' ?  : )
    let text = ''

    if (this.coupon.tipo_requisito == 'V') {
      text = 'Compra mínima R$' + this.coupon.requisito
    } else if (this.coupon.tipo_requisito == 'P') {
      text = 'Primeira compra do cliente'
    } else {
      text = this.coupon.requisito + (parseInt(this.coupon.requisito) > 1 ? ' itens' : ' item' ) + ' mínimo na compra'
    }

    return text
  }


  openDetail(coupon:ICoupon, i: number) {
    document.getElementById('detailCoupon').scrollTop = 0;

    this.showConfirmDelete = false
    this.isDeleteCupom = false
    this.open = true

    this.coupon = coupon

    this.couponUrl = this.operador.url_estabelecimento+'c/' + this.coupon.codigo

    this.status.setValue(coupon.status == 'A' ? true : false)

    this.openid = i
  }

  closeDetail() {
    this.open = false
    this.openid = null
  }

  onSubmit() {
    if (this.couponFrm.valid) {
    }
    return false
  }

  updateStatus() {
    this.coupon.status = this.status.value ? 'A' : 'I'

    this._couponService.patch(this.coupon.idcupom, {
      status: this.status.value ? 'A' : 'I'
    }).subscribe(res=>{

    })
  }

}
